export default `vec3 q;
    float s=1., a=1., n=.5;
    for(int j=0;j++<9;){
      p.xy*=rotate2D(float(j*j));
      a*=.5; q=sin(p+=p);
      n+=q.x*q.y*q.z*a;
    }
    return n*.2;
  }`